module.exports = __webpack_public_path__ + "img/pp3.25d79a41.png";